export default "__VITE_ASSET__CRHY_sCd__"